import { createApp } from 'vue'

document.addEventListener('turbo:load', () => {
  const el = document.querySelector('.vue-optional-description')
  if (el) {
    const description = JSON.parse(el.dataset.descriptionValue)
    const app = createApp({
      data () {
        return {
          description,
          isOpen: false
        }
      }
    })
    app.mount(el)
  }
})
